export default __webpack_public_path__ + "static/media/map-pin-striped-building.73068cdf.svg";